import React from "react";
import { Alert, Divider } from "@mui/material";
import { LeftSidebar } from "layout-blueprints";
import StandardHeader from "./global/StandardHeader";
import { needsMessage, useCan } from "../modules/settings/accessRoles";

// Wraps a page that needs a role. People without it see why, instead of the page.
export default function RequireCapability({ capability, title, children }) {
  const can = useCan();
  if (can(capability)) return children;
  return (
    <LeftSidebar page={title}>
      <StandardHeader title={title} />
      <Divider className="mb-3 mt-3" />
      <Alert severity="info">{needsMessage(capability)} Ask a super admin if you need it.</Alert>
    </LeftSidebar>
  );
}
